import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
// import * as amplitude from '@amplitude/analytics-browser';

import './index.css';
import App from './app/app';
import initStore from './store';

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const SENTRY_SAMPLING_RATE = process.env.REACT_APP_SENTRY_SAMPLING_RATE;
const ENVIROMENT = process.env.REACT_APP_ENV;
const RELEASE = process.env.npm_package_version;
// const AMPLITUDE_VAR = process.env.REACT_APP_AMPLITUDE_VAR!;

if (ENVIROMENT === 'production') {
  // amplitude.init(AMPLITUDE_VAR);

  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
    environment: ENVIROMENT,
    release: RELEASE,
    // Performance Monitoring
    // Capture 100% of the transactions, reduce in production!
    tracesSampleRate: Number(SENTRY_SAMPLING_RATE) || 0,
    // Session Replay
    // This sets the sample rate at 10%.
    // You may want to change it to 100% while in development
    // and then sample at a lower rate in production.
    replaysSessionSampleRate: 0.0,
    // If you're not already sampling the entire session,
    // change the sample rate to 100% when sampling sessions where errors occur.
    replaysOnErrorSampleRate: 0.2,
    ignoreErrors: [
      'TypeError: Failed to fetch',
      'TypeError: NetworkError when attempting to fetch resource.',
    ],
  });
}

const store = initStore({});
ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
  document.getElementById('root'),
);
